import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-orders',
    templateUrl: './failed.component.html',
    styleUrls: ['./failed.component.scss'],
    standalone: false
})
export class FailedComponent implements OnInit {

    constructor() { }

    ngOnInit(): void {
    }

}
